/* eslint-disable no-restricted-syntax */
import type { ConfigType } from 'dayjs';
import dateUtil from './dateUtil';

const dateUtilFormat = (date: ConfigType, format: string | undefined): string => dateUtil(date).format(format);

export default dateUtilFormat;
